import { SVGProps } from "react";

export default function StepIcon2(props: SVGProps<SVGSVGElement>) {
  return (
<svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 5.83398H7.16667M16.3333 5.83398H18M16.3333 5.83398C16.3333 7.2147 15.214 8.33398 13.8333 8.33398H12.1667C10.786 8.33398 9.66667 7.2147 9.66667 5.83398C9.66667 4.45327 10.786 3.33398 12.1667 3.33398L13.8333 3.33398C15.214 3.33398 16.3333 4.45327 16.3333 5.83398ZM13.8333 14.1673H18M3 14.1673H4.66667M4.66667 14.1673C4.66667 15.548 5.78595 16.6673 7.16667 16.6673H8.83333C10.214 16.6673 11.3333 15.548 11.3333 14.1673C11.3333 12.7866 10.214 11.6673 8.83333 11.6673H7.16667C5.78595 11.6673 4.66667 12.7866 4.66667 14.1673Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
 );
};
